import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { connect } from "react-redux";

import WP from "WP";

import SmartLink from "partials/SmartLink";
import IconSelector from "partials/IconSelector";
import Image from "partials/Image";
import Button from "partials/Button";
import MobileHotelCard from "partials/HotelCard/MobileHotelCard";
import FavoriteButton from "partials/FavoriteButton";

import Media from "css/Media";

const HotelCard = (props) => {
  const { hotel, idx, visbookData, availability } = props;
  const [price, setPrice] = useState(null);

  useEffect(() => {
    if (visbookData && visbookData.prices) {
      let calculatedPrice = visbookData.prices[0].calculatedPrice;
      let numRooms = availability.numRooms;
      let price = calculatedPrice * numRooms;

      setPrice("NOK " + price.toLocaleString("fr"));
    } else {
      let sortedByPrice = [];
      hotel.acf.room_types
        .map((room) => {
          sortedByPrice.push(parseInt(room.from_price));
          return null;
        })
        .sort();
      if (sortedByPrice[0]) {
        setPrice("NOK " + sortedByPrice[0].toLocaleString("fr"));
      }
    }
  }, [visbookData]);

  const getDates = () => {
    if (visbookData && visbookData.prices) {
      return visbookData.prices[0].steps.length;
    } else return null;
  };

  const getRooms = () => {
    if (visbookData && visbookData.prices) {
      return availability.numRooms;
    } else return null;
  };

  return (
    <React.Fragment>
      <Wrapper key={hotel.id} className='hotelCard'>
        <StyledFavoriteButton sort={hotel.type} item={hotel} hasBackground />
        <SmartLink to={hotel.link}>
          <StyledImage
            image={hotel.acf.featured_image}
            ratio='5:4.4'
            background
          >
            <Title>{hotel.acf.item_name}</Title>
          </StyledImage>
        </SmartLink>
        <InfoBox>
          <KeyFeatures>
            {hotel.acf.key_features &&
              hotel.acf.key_features.map((feature, idx) => {
                return (
                  <li key={idx}>
                    <IconSelector icon={feature.icon} />
                    <span>{feature.feature_name}</span>
                  </li>
                );
              })}
          </KeyFeatures>
          <PriceInfo>
            <div>
              {visbookData && visbookData.prices && (
                <span>
                  {getRooms()} {WP.trans.rooms}, {getDates()} {WP.trans.nights}
                </span>
              )}
              {price && (
                <span>
                  {WP.trans.from} {price}
                </span>
              )}
            </div>
            <SmartLink to={hotel.link}>
              <Button>{WP.trans.chooseHotel}</Button>
            </SmartLink>
          </PriceInfo>
        </InfoBox>
      </Wrapper>
      <StyledMobileHotelCard
        hotel={hotel}
        isFiltered={visbookData && visbookData.prices}
        getRooms={getRooms()}
        getDates={getDates()}
        price={price}
        idx={idx}
      />
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  availability: state.availability,
});

export default connect(mapStateToProps, null)(HotelCard);

const Wrapper = styled.div`
  display: none;

  ${Media.greaterThan("s")`
    display: block;
  `}
`;

const StyledFavoriteButton = styled(FavoriteButton)`
  display: flex;
  justify-content: end;
  align-items: center;
  width: 63.97px;
  height: 61.597px;
  position: absolute;
  z-index: 2;
  top: 0;
  right: calc((100vw - 80px) / 100 * 8.8);

  ${Media.greaterThan("s")`
        width: 103.97px;
        height: 101.597px;
        right: calc((100vw - 80px) / 100 * 3.65);
    `}

  ${Media.greaterThan("m")`
        right: calc((100vw - 80px) / 100 * 2.59);
    `}
`;

const StyledImage = styled(Image)`
  &::after {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    content: "";
    background-color: transparent;
    transition: all 0.2s ease-in;
  }

  &:hover {
    &::after {
      background-color: rgba(0, 0, 0, 0.2);
    }
    svg {
      opacity: 1;
    }
  }
`;

const Title = styled.span`
  display: block;
  ${(props) => props.theme.fonts.h3}
  position: absolute;
  bottom: 0;
  left: 0;
  background-color: ${(props) => props.theme.colors.negative};
  color: ${(props) => props.theme.colors.text}!important;
  padding: ${(props) => props.theme.spacing.contentL}
    ${(props) => props.theme.spacing.elementXS};
  width: 78.719723183391%;
  z-index: 1;
`;

const KeyFeatures = styled.ul`
  width: 50%;

  li {
    display: flex;
    align-items: center;
    padding-bottom: ${(props) => props.theme.spacing.contentL};

    span {
      ${(props) => props.theme.fonts.p}
    }
  }
`;

const PriceInfo = styled.div`
  width: 50%;

  > div {
    padding-bottom: ${(props) => props.theme.spacing.contentM};

    span {
      display: block;
      ${(props) => props.theme.fonts.p}
      text-align: center;
    }
  }
`;

const InfoBox = styled.div`
  width: 100%;
  display: flex;
  padding: ${(props) => props.theme.spacing.contentXL}
    ${(props) => props.theme.spacing.elementXS};
  background-color: ${(props) => props.theme.colors.bg};
  color: ${(props) => props.theme.colors.text};
`;

const StyledMobileHotelCard = styled(MobileHotelCard)`
  display: block;

  ${Media.greaterThan("s")`
    display: none;
  `}
`;
